import { REVERSAL } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section className="relative pt-[104px] overflow-hidden" id="top">
      {/* 背景装饰 */}
      <div className="pointer-events-none absolute -right-24 top-10 w-[520px] h-[520px] rounded-full bg-brand-100/70 blur-2xl" />
      <div className="pointer-events-none absolute left-0 bottom-0 w-72 h-72 bg-amber-100/60 blur-2xl" />

      <div className="relative max-w-[1200px] mx-auto px-4 md:px-6 pt-10 md:pt-16 pb-12 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-start">
          {/* 左：报头文案 */}
          <div className="lg:col-span-7">
            <p className="flex items-center gap-2 text-sm font-semibold text-brand-600 mb-4">
              <span className="w-2 h-2 rounded-full bg-brand-500 pulse-dot" />
              热点事件 · 持续追踪中
            </p>
            <h2 className="font-heading font-black text-[40px] leading-[1.12] md:text-[64px] md:leading-[1.08] text-ink-900 tracking-tight">
              今天的瓜，
              <br />
              追到<span className="text-brand-600">哪一步</span>了？
            </h2>
            <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-ink-600">
              事件发酵、二次爆料与反转剧情都更新到最新。想看哪个瓜现在走到哪一步，顺着持续更新就能读——关键节点、展开细节与舆论方向，一页掌握。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 px-6 h-12 rounded-full bg-brand-500 text-paper-50 text-base font-semibold hover:bg-brand-600 whitespace-nowrap transition-colors"
              >
                去实时热瓜榜
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#reversal"
                className="inline-flex items-center justify-center gap-2 px-6 h-12 rounded-full border border-ink-300 text-ink-800 text-base font-semibold hover:border-brand-400 hover:text-brand-600 whitespace-nowrap transition-colors"
              >
                <i className="ri-arrow-left-right-line" />
                看焦点反转
              </a>
            </div>
            <dl className="mt-10 flex items-center gap-8 md:gap-12">
              {[
                { v: "6", k: "今日在追热瓜" },
                { v: "分钟级", k: "更新频率" },
                { v: "4.8万+", k: "编辑部收录节点" },
              ].map((s) => (
                <div key={s.k}>
                  <dt className="sr-only">{s.k}</dt>
                  <dd className="font-heading font-black text-3xl text-ink-900">{s.v}</dd>
                  <dd className="text-xs text-ink-500 mt-1 tracking-wide">{s.k}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* 右：今日爆瓜焦点卡 */}
          <div className="lg:col-span-5">
            <article className="relative rounded-2xl overflow-hidden bg-paper-100 border border-ink-200/60 shadow-soft group">
              <div className="relative h-52 md:h-60 overflow-hidden">
                <img
                  src={REVERSAL.image}
                  alt="《落日信箱》反转时间线复盘 焦点事件配图"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute top-3 left-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-rose-500 text-paper-50 text-xs font-bold">
                  <i className="ri-arrow-left-right-line text-sm" />
                  本周焦点反转
                </span>
              </div>
              <div className="p-5">
                <p className="text-xs text-ink-500">今日爆瓜 · 编辑强推</p>
                <h3 className="font-heading font-bold text-lg leading-snug text-ink-900 mt-1.5">{REVERSAL.title}</h3>
                <p className="mt-2 text-sm text-ink-600 leading-relaxed line-clamp-2">{REVERSAL.lead}</p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-brand-50 text-brand-700">二次爆料</span>
                  <span className="text-xs px-2.5 py-1 rounded-full bg-mint-100 text-mint-600">时间线复盘</span>
                  <a
                    href="#reversal"
                    className="ml-auto text-sm font-semibold text-brand-600 hover:text-brand-700 inline-flex items-center gap-1"
                  >
                    跟着更新追
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}